<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="back-flex">
                        <div class="btn-width-100">
                            <router-link to="/wallets" class="btn btn-success my-2 btn-width-100">{{ $t('label.back') }}</router-link>
                        </div>
                    </div>
                    <div class="h5" v-text="$t('wallets.label.charge_wallet')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label v-text="$t('wallets.label.amount_rial')"></label>
                    <amount-input
                            item_id="amount"
                            item_name="amount"
                            :item="form_data"
                    ></amount-input>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="settlement_period">{{ $t('label.bank_title') }}</label>
                    <select v-model="form_data.bank_id"
                            name="bank_id"
                            id="bank_id"
                            class="form-control"
                    >
                        <option  selected value="062"> آینده</option>
                        <option  value="019"> صادرات</option>
                        <option  value="056">سامان</option>
                    </select>
                </div>
                <div class="col-12 col-md-6 my-2" v-if="banks_need_iban.includes(form_data.bank_id)">
                    <label for="iban_number">{{ $t('label.account') }}</label>
                    <select v-model="form_data.iban_number"
                            name="iban_number"
                            id="iban_number"
                            class="form-control"
                    >
                        <option v-for="iban in getShebaNumbers(form_data.bank_id)"> {{iban}}</option>
                    </select>
                </div>
                <div class="col-12 mt-4">
                    <button id="chargeByOauthBtn" class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import AmountInput from "@/components/custom-elements/amount-input";
    import {mapGetters} from "vuex";
    import IranSheba from "iran-sheba";

    export default {
        components: {AmountInput},
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        computed: {
            ...mapGetters("shebaNumber", ["sheba_numbers"]),
        },
        mounted() {
            this.$store.dispatch("shebaNumber/fetch").then((response) => {
                this.sheba_numbers.forEach((element) => {
                    if (this.getBankNickname(element.number) === 'saderat') {
                        this.saderat_sheba_numbers.push(element.number)
                    }
                    if (this.getBankNickname(element.number) === 'saman') {
                        this.saman_sheba_numbers.push(element.number)
                    }
                })
            });
        },
        data(){
            return {
                data_form:{
                    bank_title:0
                },
                saderat_sheba_numbers :[],
                saman_sheba_numbers: [],
                banks_need_iban : [
                    '019',
                    '056'
                ]
            }
        },
        methods :{
            getBankNickname(sheba) {

                sheba = 'IR'+sheba.replace(/-/g,'').replace(/IR/g,'')
                const bank = IranSheba.recognize(sheba);
                if (bank) {
                    return bank.nickname;
                }
                return "central-bank"; // default value for when this function failed to recognize the bank name
            },

            getShebaNumbers(bank_id) {
                if (bank_id === '019') {
                    return this.saderat_sheba_numbers
                }

                if (bank_id === '056') {
                    return this.saman_sheba_numbers
                }

                return []
            }
        }
    }
</script>

<style scoped>
.back-flex {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}

@media screen and (max-width:678px){
    .back-flex {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
    /* .btn-width-100 {
        width: 100%;
    } */
}
</style>